module.exports = __webpack_public_path__ + "static/media/cook.66d2cc24.png";